import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import SearchableSongList from "pages/SongsPage/components/SearchableSongList";
import { rootSelectors, RootState } from "state/rootReducer";
import { actions } from "state/slices/songsSlice";
import { LoadingSpinner } from "components/LoadingSpinner/LoadingSpinner";
import { useOpenSong } from "shared/navigation";

interface StateProps {
  isLoggedIn: boolean;
  songs: Song[];
  searchResults: Song[] | null;
  searchString: string;
}

interface DispatchProps {
  onFetchAllSongs: typeof actions.fetchAllSongs;
}

export type SongsPageProps = StateProps & ResolveThunks<DispatchProps>;

/** Discover's search. A chosen song opens at /songs/:gid (SongDetailPage). */
export function SongsPage(props: SongsPageProps): JSX.Element {
  const openSong = useOpenSong();

  useEffect(() => {
    if (props.songs.length === 0) {
      props.onFetchAllSongs();
    }
  }, []);

  function render(): JSX.Element {
    return renderContent();
  }

  function renderContent(): JSX.Element {
    if (props.isLoggedIn) {
      return props.songs?.length === 0 && props.searchString.length === 0 ? (
        <LoadingSpinner border={false} />
      ) : (
        <SearchableSongList
          songs={props.songs}
          selectSongHandler={openSong}
          initialSearchString={props.searchString}
        />
      );
    } else {
      return (
        <div style={{ marginTop: 8, marginLeft: 8 }}>
          <p>Please login to Spotify to use the service.</p>
        </div>
      );
    }
  }

  return render();
}

function mapState(state: RootState): StateProps {
  return {
    searchString: state.songs.currentSearch,
    songs: rootSelectors.songs.getAllSongs(state),
    searchResults: rootSelectors.songs.getSongsServerSide(state),
    isLoggedIn: !!rootSelectors.user.getCurrentUser(state),
  };
}

const mapDispatch: DispatchProps = {
  onFetchAllSongs: actions.fetchAllSongs,
};

export default connect(mapState, mapDispatch)(SongsPage);
